module.exports = __webpack_public_path__ + "static/media/hag-popup.3f353337.svg";